import { render } from "./tzzhd.vue?vue&type=template&id=736a4dc2&scoped=true&ts=true"
import script from "./tzzhd.vue?vue&type=script&lang=ts"
export * from "./tzzhd.vue?vue&type=script&lang=ts"

import "./tzzhd.vue?vue&type=style&index=0&id=736a4dc2&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736a4dc2"]])

export default __exports__